import { Avatar, Card, Collapse } from 'antd';
import axios from 'axios';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getServiceUrl } from '../../config';
import { BiSolidCheckCircle, BiSolidXCircle } from 'react-icons/bi';

const API_BASE_URL = getServiceUrl();

function Summary({ patientData }) {
  const params = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPatientData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('tokenId');
        const response = await axios.get(
          `${API_BASE_URL}patient/getpatientdata`,
          {
            headers: {
              rdxtoken: token,
              patientguid: params.patientguid,
            },
          },
        );
        setData(response.data);
      } catch (err) {
        console.error('Error fetching chatbot results!', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPatientData();
  }, [params.patientguid]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  // Assume the API returns an array and we're only interested in the first element.
  const patient = data?.[0];

  return (
    <div className="mx-auto h-[80vh] w-4/5 overflow-y-auto">
      {/* Patient card */}
      <Card title="Assessment" className="mb-3 w-full">
        <div className="flex gap-3">
          <Avatar
            shape="square"
            size={50}
            src={`https://ui-avatars.com/api/?name=${patient.firstname}+${patient.lastname}`}
          />
          <div>
            <p className="font-semibold">{`${patient.firstname} ${patient.lastname}`}</p>
            <span className="text-sm text-gray-600">
              created on {patient.created_at}
            </span>
          </div>
        </div>
        <p className="mt-3">
          {patient.response_message === '✅ Assessment complete!' ? (
            <span>
              <BiSolidCheckCircle
                className="mx-1 inline text-green-600"
                size={25}
              />
              Assessment Completed
            </span>
          ) : (
            <span>
              <BiSolidXCircle className="inline text-red-500" size={25} />
              Assessment Not Completed
            </span>
          )}
          <span
            className={clsx('mx-2 rounded-md p-2', {
              'bg-red-100 text-red-500': patient.risk_level === 'High Risk',
              'bg-yellow-100 text-yellow-500':
                patient.risk_level === 'Medium Risk',
              'bg-green-100 text-green-500': patient.risk_level === 'Low Risk',
            })}
          >
            {patient.risk_level}
          </span>
        </p>
      </Card>

      <Collapse className="mb-3">
        <Collapse.Panel header="Patient summary" key="1">
          <p className="font-semibold text-slate-800">{patient.summary}</p>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}

export default Summary;
